import { Field, FieldLabel, RadioGroup, RadioGroupItem } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

export interface DateConfigFieldsProps {
  config: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  disabled: boolean;
}

// Wire values persisted in `config.format` — must match the backend's
// `DateSectionConfigDto.format` enum exactly. Not user-facing copy; the
// translated label comes from `labelKey` below.

const FORMATS = [
  {
    // eslint-disable-next-line i18next/no-literal-string -- protocol value: DateSectionConfigDto's `@IsIn(['Start date only', 'Start + End date'])` validates this exact string server-side; translating it would break the wire contract.
    value: 'Start date only',
    labelKey: 'knowledgeHub.briefSectionConfigFields.formatStartDateOnly',
  },
  {
    // eslint-disable-next-line i18next/no-literal-string -- see the entry above.
    value: 'Start + End date',
    labelKey: 'knowledgeHub.briefSectionConfigFields.formatStartAndEndDate',
  },
] as const;

export function DateConfigFields(props: DateConfigFieldsProps) {
  const { t } = useTranslation('knowledge');
  const format = typeof props.config.format === 'string' ? props.config.format : FORMATS[0].value;

  return (
    <Field>
      <FieldLabel>{t('knowledgeHub.briefSectionConfigFields.format')}</FieldLabel>
      <RadioGroup
        value={format}
        onValueChange={(next: string) => props.onChange({ format: next })}
        disabled={props.disabled}
      >
        {FORMATS.map((option) => (
          <label key={option.value} className="flex items-center gap-2 text-sm">
            <RadioGroupItem value={option.value} />
            {t(option.labelKey)}
          </label>
        ))}
      </RadioGroup>
    </Field>
  );
}
